
import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {UserResponse} from "../../classes/user-response";
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'natural-whole-decimal-num-type',
  templateUrl: 'natural-whole-decimal-num-type.component.html',
  styleUrls: ['natural-whole-decimal-num-type.component.css']
})
export class NaturalWholeNumTypeComponent implements OnInit{


  //Inputs used to display questions

  @Input() question_index : number;
  @Input() question_name : string;
  @Input() question_name_second : string;
  @Input() question_type : string;
  @Input() is_mandt : boolean;
  @Input() question_number : number;
  @Input() indexOfRepeater : number;
  @Input() is_range:boolean;
  @Input() userRes : string[];

  @Output() user_Resp = new EventEmitter<string[]>();

  regex : RegExp;
  max_allowed : number;
  isDecimalType : boolean;
  value : number;
  maxValue : number;

  constructor(private snackbar: MatSnackBar) {

  }
  
  ngOnInit(): void{

    // N corresponds to NaturalNumMax
    if(this.question_type.charAt(0)==='N'){

      this.max_allowed = parseInt(this.question_type.slice(13,this.question_type.length));

      this.question_type = 'N';

      this.isDecimalType = false;

    }

    //D corresponds to DecimalMax
    else if(this.question_type.charAt(0)==='D'){

      this.max_allowed = parseInt(this.question_type.slice(10,this.question_type.length));

      this.question_type = 'D';

      this.isDecimalType = true;

    }

    //W which means WholeNumMax
    else{

      this.max_allowed = parseInt(this.question_type.slice(11,this.question_type.length));

      this.question_type = 'W';

      this.isDecimalType = false;

    }


    if(this.userRes[this.indexOfRepeater] != undefined && this.userRes[this.indexOfRepeater].length > 0){

      this.value = parseInt(this.userRes[this.indexOfRepeater]);

    }

    this.regex = new RegExp("^[+-]?([0-9]*[.])?[0-9]+$");

  }

  onPressNaturalWhole(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
    if(!isNaN(parseInt(event.target.value + inputChar)) && parseInt(event.target.value + inputChar) > this.max_allowed){
      event.preventDefault();
    }
    if (this.is_range) {
      if (event.target.id == 'minInput' && this.maxValue && parseInt(event.target.value + inputChar) >= this.maxValue) {
        event.preventDefault();
      }
    }
  }

  onPressDecimal(event : any){
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar) && inputChar !== '.') {
      event.preventDefault();
    }
  }


  onKeyNaturalWhole(event: any) {
    if(event.target.value.charAt(event.target.value.length-1) === " "){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    }
  }

  onEnterNaturalWhole(event: any){
    if(this.question_type==='N' && parseInt(event.target.value) === 0){
      event.target.value = event.target.value.substring(0,event.target.value.length - 1);
    } else {
      this.value = event.target.value;
      if (this.is_range) {
        if (this.value != undefined && this.maxValue != undefined && parseInt(this.maxValue.toString()) <= parseInt(this.value.toString())) {
          this.snackbar.open("Error in setting range.", null, {
            duration: 1000
          });
        }
        else {
          this.user_Resp.emit([this.indexOfRepeater.toString(), this.question_number.toString(), this.value + " - " + (this.maxValue != undefined ? this.maxValue : 'NA')]);
        }
      }
      else {
        this.user_Resp.emit([this.indexOfRepeater, this.question_number.toString(), event.target.value.toString()]);
      }
    }
  }

  onEnterMaxWholeNum(event: any) {
    this.maxValue = event.target.value;
    if (this.value != undefined && parseInt(this.maxValue.toString()) <= parseInt(this.value.toString())) {
      this.snackbar.open("Error in setting range.", null, {
        duration: 1000
      });
    }
    else {
      this.user_Resp.emit([this.indexOfRepeater.toString(), this.question_number.toString(), this.value + " - " + this.maxValue]);
    }
  }

  //Complex logic to check various keys entered by user if they form a proper decimal number input
  onKeyDecimal(event : any){

    let indexOfDot : number = event.target.value.indexOf('.');

    let length : number = event.target.value.length;

    if(event.key==='.'){

      if(indexOfDot !== (length-1)){

        event.target.value = event.target.value.substring(0,length - 1);

      }

    }

    if(event.key!=='.' && !this.regex.test(event.target.value)){

      event.target.value = event.target.value.substring(0,length - 1);

    }

    if(  indexOfDot !== -1 && ((length - indexOfDot) >4)){

      event.target.value = event.target.value.substring(0,length - 1);

    }

    if((parseFloat(event.target.value) > this.max_allowed)){


      if(indexOfDot === -1 || indexOfDot === (length -2)){

        event.target.value = event.target.value.substring(0,length - 1);

      }else{

        event.target.value = event.target.value.substring(0,indexOfDot - 1) + event.target.value.substring(indexOfDot ,length);

      }

    }

  }

  onEnterDecimal(event : any){
    this.value = event.target.value;
    this.user_Resp.emit([this.indexOfRepeater,this.question_number.toString(),event.target.value.toString()]);

  }

}



// WEBPACK FOOTER //
// ./src/app/questions-type/natural-whole-decimal-num-type/natural-whole-decimal-num-type.component.ts